var map = {
	"./1.png": "775a",
	"./2.png": "8e30",
	"./HDKH1.png": "04aa",
	"./HDKH2.png": "3452",
	"./HDKH3.png": "467d",
	"./HS-1.jpg": "4edb",
	"./HS-16.jpg": "82aa",
	"./HS-2.jpg": "6a30",
	"./HS-6.jpg": "1edf",
	"./HS-7.jpg": "fa10",
	"./HS-8.jpg": "d737",
	"./HS-9.jpg": "18d2",
	"./HS.png": "018a",
	"./HS_de_thi.png": "4177",
	"./HSc.png": "4e64",
	"./Logo-HTS.png": "899f",
	"./_ketnoitrithuc.png": "942b",
	"./arrow-left.png": "15c5",
	"./arrow-right.png": "e9c1",
	"./arrow.png": "5a8f",
	"./bg-profile.png": "76cc",
	"./bg1.jpg": "5164",
	"./book-banner.png": "3aec",
	"./book-icon.png": "e5e5",
	"./box-ft.PNG": "7682",
	"./check.png": "06fb",
	"./class-bg.png": "02fe",
	"./class-icon.png": "1b84",
	"./close.png": "04b3",
	"./copy.png": "e61d",
	"./dots-menu.png": "8f7a",
	"./down-arrow.png": "e064",
	"./ebook-1.jpg": "772e",
	"./edit.png": "162a",
	"./files.png": "1e89",
	"./flag-profile.png": "4db4",
	"./group_people.png": "70b8",
	"./head-lt.png": "8a46",
	"./home-img.png": "a8cb",
	"./home-img1.PNG": "b0ec",
	"./home-img2.PNG": "e082",
	"./home2_1.png": "f782",
	"./home2_2.png": "7f6f",
	"./home2_3.png": "66e3",
	"./home_1.png": "109b",
	"./home_1_2.png": "c760",
	"./home_1_old.png": "bac8",
	"./home_1a.png": "6917",
	"./home_2.png": "ce41",
	"./home_3.png": "3cbe",
	"./home_4.png": "9856",
	"./i_arrow_down.png": "5084",
	"./icon-box1b.png": "4a5f",
	"./icon-box2.png": "003e",
	"./icon-box2a.png": "2f85",
	"./icon-box2b.png": "fa1d",
	"./icon-close.png": "95d9",
	"./icon-document.png": "e07a",
	"./icon-down-arrow.png": "4cda",
	"./icon-exam.png": "62c5",
	"./icon-file.png": "02a4",
	"./icon-lienket.png": "949e",
	"./icon-list.png": "7ccb",
	"./icon-page-down.png": "5d33",
	"./icon-practice.png": "8a2e",
	"./icon-symbol.png": "e2ea",
	"./icon-textbook.png": "7add",
	"./icon-up-arrow.png": "ec4f",
	"./icon_bdgd.png": "4a7f",
	"./icon_groups.png": "2086",
	"./icon_pt.png": "a86b",
	"./iconfb.jpg": "dd47",
	"./img-ex.png": "56ed",
	"./img-ex2.png": "5784",
	"./img-hts1.png": "3a49",
	"./img-hts2.png": "5c2b",
	"./img-hts3.png": "8487",
	"./img-hts4.png": "1bd3",
	"./library-icon.png": "ec12",
	"./line-profile.png": "ab01",
	"./link.png": "9ddd",
	"./logo-1.png": "cbd1",
	"./logo-home.png": "1db8",
	"./logo-nxb.jpg": "cb0a",
	"./logo-st.png": "5907",
	"./logo_hts.png": "dfc7",
	"./lt-box1.png": "63ec",
	"./lt-box2.png": "a148",
	"./lt-box3.png": "a8b2",
	"./lt-box4.png": "84f1",
	"./lt-tiengviet1.png": "6ebd",
	"./lt-toan1.png": "183c",
	"./no-image.png": "afa5",
	"./nxb.jpg": "b5ca",
	"./open-book.png": "d105",
	"./pencil-icon.png": "53fd",
	"./photo.png": "b98a",
	"./play.png": "d99c",
	"./plus-hover.png": "dff4",
	"./plus.png": "a851",
	"./preparation.png": "00de",
	"./question-icon.png": "eb69",
	"./sach_ctst.png": "ad43",
	"./sach_kntt.png": "14ac",
	"./section-left-bg.png": "d7f2",
	"./section-right-bg.png": "f92f",
	"./show-more-down.png": "b6a1",
	"./student-profile.png": "76dd",
	"./target-profile.png": "558f",
	"./trash_light.png": "ed66",
	"./upload.png": "f325",
	"./x.png": "5610"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";